import React, { useState } from "react";
import api from "../api/axios";
import { useNavigate } from "react-router-dom";
import LoginForm from "./LoginForm";

export default function Login() {
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();

  const handleUserLogin = async ({ email, password }) => {
    setLoading(true);
    setMessage("");
    try {
        const res = await api.post("/api/auth/login", { email, password });
        if (!res.data.token) {
          setMessage("トークンが取得できませんでした");
          return;
        }
        localStorage.setItem("token", res.data.token);
        api.defaults.headers.common.Authorization = `Bearer ${res.data.token}`;
        setMessage("ログイン成功");
        navigate("/");
      } catch (err) {
        console.error(err);
        setMessage(err.response?.data?.message || "エラーが発生しました");
      } finally {
        setLoading(false);
      }
    };

  return (
    <div style={{ maxWidth: 400, margin: "0 auto", padding: 20 }}>
      <LoginForm title="ログイン" onSubmit={handleUserLogin} />
      {message && <p style={{ marginTop: 10, color: "red" }}>{message}</p>}
      {loading && <p>ログイン中...</p>}
      <div style={{ marginTop: 10 }}>
        <a href="/forgot-password">パスワードを忘れた場合はこちら</a>
      </div>
    </div>
  );
}